module.exports = "//static.hsappstatic.net/LoginUI/static-1.14876/img/connect.com-full-logo-color.svg"